import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from "vue";
import NavigationBar from "../shared/NavigationBar.vue";
import NaverMap from "./NaverMap.vue";
import { IAddressSearchInfo } from "@/domain/entities/address";


const __default__ = {
  name: "AddressInfoMap",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  address: {
    type: Object as PropType<IAddressSearchInfo>,
  },
},
  emits: ["onClickClose"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const infoWindowContent = computed(() => {
  if (!props.address?.roadAddress && !props.address?.dongAddress) return "";

  const { roadAddress, dongAddress } = props.address;
  const address = roadAddress?.length ? roadAddress : dongAddress;

  return `<div class="info-wrapper">
      <p>${address}</p>
    </div>`;
});

const emitOnClickClose = () => {
  emit("onClickClose");
};

const __returned__ = { props, emit, infoWindowContent, emitOnClickClose, NavigationBar, NaverMap }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})